// redux/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
  name: "",
  surname: "",
  email: "",
  password: "",
  isLoggedIn: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      const { id, name, surname, email, password } = action.payload;
      state.id = id;
      state.name = name;
      state.surname = surname;
      state.email = email;
      state.password = password;
      state.isLoggedIn = true;
    },
    updateUser(state, action) {
      const { name, surname, email, password } = action.payload;
      state.name = name;
      state.surname = surname;
      state.email = email;
      state.password = password;
    },
    clearUser(state) {
      Object.assign(state, initialState);
    },
  },
});

export const { setUser, updateUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
